import React from "react";
import { useLocation } from "react-router-dom";
import BackButton from "../../../components/BackButton";
import Card from "../../../components/Card";
import SubMenu from "../../../components/SubMenu";
import Layout from "../../../layout";
import About from "./About";
import Account from "./Account";
import Notificationsd from "./Notifications";
import Security from "./Security";
import Support from "./Support";
// import Faqs from "./Faqs";
// import Bank from "./Bank";
import Developer from "./Developer";

const subMenuOptions = [
  ["notifications", "/settings/notifications"],
  ["my account", "/settings/account"],
  ["security", "/settings/security"],
  // ["bank", "/settings/bank"],
  ["help/support", "/settings/help"],
  // ["faqs", "/settings/faqs"],
  ["about", "/settings/about"],
  ["developer", "/settings/developer"],
];

const Settings = () => {
  const { pathname } = useLocation();

  const isFaqs = pathname.includes("faqs");

  const displaySection = () => {
    if (pathname.includes("account")) {
      return <Account />;
    } else if (pathname.includes("security")) {
      return <Security />;
    // } else if (pathname.includes("bank")) {
    //   return <Bank />;
    } else if (pathname.includes("help")) {
      return <Support />;
   
    } else if (pathname.includes("about")) {
      return <About />;
    } else if (pathname.includes("developer")) {
      return <Developer />;
    } else {
      return <Notificationsd />;
    }
  };

  return (
    <Layout>
      <div className="d-flex flex-column flex-md-row mt-3">
        <div
          className="sub-menu-container"
          style={{ position: "sticky", top: "90px", alignSelf: "flex-start" }}
        >
          <BackButton />
          <SubMenu menuOptions={subMenuOptions} includeSVG />
        </div>
        <div className="main-content ml-md-4">
          <Card
            additionalClass="p-5"
            additionalStyle={
              isFaqs
                ? {
                    maxHeight: "calc(100vh - 140px)",
                    overflowY: "auto",
                  }
                : undefined
            }
          >
            {displaySection()}
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default Settings;
